type Props = {
  // supTitle?: string;
  title?: string;
  subTitle?: string;
  children?: React.ReactNode;
};

export default function FeatureSectionWrapper({
  title,
  subTitle,
  children,
}: Props) {
  return (
    <div className="relative py-8 bg-white sm:py-2124 lg:py-16">
      <div className="max-w-md px-4 mx-auto text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8">
        {/* <h2 className="text-base font-semibold tracking-wider uppercase text-primary-600">
          Deploy faster
        </h2> */}
        {title && (
          <h2 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            {title}
          </h2>
        )}
        {subTitle && (
          <p className="mx-auto mt-5 text-xl text-gray-500 max-w-prose">
            {subTitle}
          </p>
        )}
        <div className="my-12">{children}</div>
      </div>
    </div>
  );
}
